import React from 'react';

import { HStack, Stack } from '@chakra-ui/react';

import { ScanVaultCentralAccount } from 'api/scan-vault/client';
import { DetailsIdentifier, EllipsisText } from 'components/DataDisplay';
import { useCloudAccountId } from 'containers/Setup/CloudAccounts/utils';
import { outpostDetailsLabelStyles } from 'containers/Setup/Outpost/Components/styles';
import { OutpostInfoBox } from 'containers/Setup/Outpost/Components/utils';

interface Props {
  row: ScanVaultCentralAccount;
}

export const CentralScanningCommonFields = (props: Props) => {
  const { row } = props;
  const { cloudAccountIDMapping } = useCloudAccountId();

  return (
    <Stack spacing={4}>
      <HStack spacing={8}>
        <OutpostInfoBox w="full">
          <DetailsIdentifier
            label="Account"
            value={
              <EllipsisText>
                {cloudAccountIDMapping?.[row.account_id]?.name}
              </EllipsisText>
            }
            isInline={false}
            {...outpostDetailsLabelStyles}
          />
        </OutpostInfoBox>
        <OutpostInfoBox w="full">
          <DetailsIdentifier
            label="Cloud ID"
            value={cloudAccountIDMapping?.[row.account_id]?.cloud_account_id}
            isInline={false}
            {...outpostDetailsLabelStyles}
          />
        </OutpostInfoBox>
      </HStack>

      <OutpostInfoBox>
        <DetailsIdentifier
          label="Scanned By"
          value="Ariksa"
          isInline={false}
          {...outpostDetailsLabelStyles}
        />
      </OutpostInfoBox>
    </Stack>
  );
};
